// removed by extract-text-webpack-plugin
module.exports = {"input":"Checkbox-input"};